/* eslint-disable max-len, no-await-in-loop, no-new, no-unused-vars, padded-blocks */
/* eslint no-shadow: ["error", { "allow": ["state"] }] */
import api from '@/api';

export const namespaced = true;

export const state = {
  errorMessage: null,
  product: null,
};

export const actions = {
  async getProductAsync({ commit }, factors) {
    const response = await api.get(`/mathhelper/product?x=${factors.x}&y=${factors.y}`);
    return response.data;
  },
  async getSumAsync({ commit }, addends) {
    const response = await api.post('/mathhelper/sum', addends);
    return response.data;
  },
};

export const mutations = {
  SET_PRODUCT(state, data) {
    state.product = data;
  },
  SET_ERROR_MESSAGE(state, errorMessage) {
    state.errorMessage = errorMessage;
  },
};
